function extractDocumentId(driveDocumentLink: string) {
  let result = driveDocumentLink.match(/\/d\/([^\/]*)/);
  return result == null ? "" : result[1];
}

function createDownloadLinkFromId(documentId: string) {
  return "https://drive.google.com/uc?export=download&id=" + documentId;
}

export function createDownloadUrlForGoogleDrive(googleDriveShareLink: string) {
  return createDownloadLinkFromId(extractDocumentId(googleDriveShareLink));
}

export function isGoogleDriveUrl(url: string) {
  return /drive.google/.test(url);
}

export function DriveDownloadLink(props: {
  text: string;
  driveDocumentLink: string;
  style?: any;
}) {
  return (
    <a
      style={{ fontSize: "18px", color: "blue", ...props.style }}
      href={createDownloadLinkFromId(
        extractDocumentId(props.driveDocumentLink)
      )}
      download
    >
      {props.text}
    </a>
  );
}
